export const TITLE_GRAPHIC_POSITIONS = ["top", "center", "bottom"] as const;
export type TitleGraphicPosition = typeof TITLE_GRAPHIC_POSITIONS[number];

export function getTitleGraphicPosition(value: unknown): TitleGraphicPosition {
  return value === "top" || value === "bottom" ? value : "center";
}